module.exports = __webpack_public_path__ + "img/sobre-vehiculo.503488ca.webp";